import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { AuthorService } from '../../../core/routing/services/partner_content/author.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { PartnerUser } from '../Authors/Interface/authors.i';
import { AuthorConstant } from '../../../core/routing/services/partner_content/constants/author.constant';
import { ReviewPartnerContentComponent } from '../Review-partner-content/review-partner-content.component';
import { PartnerContentStore } from '../store/partner-content-store';

@Component({
  selector: 'iposcen-partner-content',
  templateUrl: './partner-content.component.html',
  styleUrls: ['./partner-content.component.scss']
})
export class PartnerContentComponent implements OnInit {
  tabIndex: number;
  @ViewChild('review') review: ReviewPartnerContentComponent;
  partnerData;
  currentdetailPage: string;
  showView: boolean;
  showReview: boolean;
  showAttrView: boolean;
  contentID: string;
  attractID: string;
  adminRef: boolean;
  pid: string;
  autoID: string;
  selectPartner;
  isPartnerTabActive: boolean;
  partnerDetails: PartnerUser[] = [];
  isAuthorDisabled: boolean = false;
  checkStatus: boolean;
  checkStatusView: boolean;
  contentsData: any;
  partnerDataGet: any;
  isCommentEnabled = false;
  authorDisabledMsg = AuthorConstant.AUTHORS_TAB_DISABLED_MSG;
  private ngUnsubscribe = new Subject();
  constructor(private router: Router, private authrService: AuthorService, private stor: PartnerContentStore) { }

  ngOnInit(): void {
    this.tabIndex = 0;
    this.currentdetailPage = this.router.url;
    this.showView = false;
    this.showReview = false;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.REVIEW_PARTNER_CONTENT) {
      this.tabIndex = 0;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.APPROVED_PARTNER_CONTENT) {
      this.tabIndex = 1;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.PARTNERS) {
      this.tabIndex = 2;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.AUTHORS) {
      this.tabIndex = 3;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.OEM_SYSTEM_IDS) {
      this.tabIndex = 4;
    }
    this.getPartner();
  }
  setIndex(ind: number) {
    this.stor.setPartnerData([]);
    if (ind === 0) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PARTNER_CONTENT + GlobalConstants.SLASH
        + GlobalConstants.REVIEW_PARTNER_CONTENT);
    } else if (ind === 1) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PARTNER_CONTENT + GlobalConstants.SLASH +
        GlobalConstants.APPROVED_PARTNER_CONTENT);
    } else if (ind === 2) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PARTNER_CONTENT + GlobalConstants.SLASH + GlobalConstants.PARTNERS);
    } else if (ind === 3) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PARTNER_CONTENT + GlobalConstants.SLASH + GlobalConstants.AUTHORS);
    } else if (ind === 4) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PARTNER_CONTENT + GlobalConstants.SLASH + GlobalConstants.OEM_SYSTEM_IDS);
    }
  }
  showReviews(event) {
    this.showReview = event;
  }

  getPartner() {
    this.authrService.getPartnerData()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.partnerDetails = data.partner as PartnerUser[];
        if (this.partnerDetails.length === 0) {
          this.isAuthorDisabled = true;
        }
      })
  }
  tabIndexSet(data) {
    this.tabIndex = data;
    this.showReview = false;
  }
}
